import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  exports: [ DashboardComponent ],
  declarations: [ DashboardComponent ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.module.ts